module.exports = __webpack_public_path__ + "static/media/rydz logo new one.328e2670.png";